import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';

import SelectField from '../../../../common/select_field';
import { getAllPodsState } from '../../../../../features/pod/get_all_pods';
import { getProductBatchesState } from '../../../../../features/inventory/get_product_batches';

const ExpirationPromotionsFilters = ({ onSelectProductBatchIdChange, onSelectPodChange }) => {
    const [productBatchNumber, setProductBatchNumber] = useState('none');
    const [podId, setPodId] = useState('none');

    const getProductBatches = useSelector(getProductBatchesState);
    const getAllPods = useSelector(getAllPodsState);

    const _onSelectProductBatchIdChange = (event) => {
        const value = event.target.value;
        setProductBatchNumber(value);
        onSelectProductBatchIdChange(value === 'none' ? '' : value);
    };

    const _onSelectPodChange = (event) => {
        const value = event.target.value;
        setPodId(value);
        onSelectPodChange(value === 'none' ? '' : value);
    };

    return (
        <Box sx={ { display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' } }>
            <Box sx={ { minWidth: '200px', flexGrow: 1 } }>
                <SelectField
                    size="small"
                    label="Szukaj po numerze partii"
                    value={ productBatchNumber }
                    onChange={ _onSelectProductBatchIdChange }
                    options={ [{
                        value: 'none',
                        label: 'Wszystkie partie'
                    }, ...getProductBatches?.data?.map(productBatch => ({
                        value: productBatch?.productBatchId,
                        label: productBatch?.productBatchId
                    }))] }
                />
            </Box>
            <Box sx={ { minWidth: '250px', flexGrow: 2 } }>
                <SelectField
                    size="small"
                    label="Szukaj po podzie"
                    value={ podId }
                    onChange={ _onSelectPodChange }
                    options={ [{
                        value: 'none',
                        label: 'Wszystkie punkty (pody)'
                    }, ...getAllPods?.data?.map(pod => ({
                        value: pod?.id,
                        label: pod?.indoorPartner?.name + ' (' + pod?.description + ') - ' + (pod?.device?.serviceId || 'brak urządzenia')
                    }))] }
                />
            </Box>
        </Box>
    );
};

export default ExpirationPromotionsFilters;